import React, {
  useState,
  forwardRef,
  useImperativeHandle,
  useEffect,
  useRef,
} from "react";
import StepperNavigationButtons from "../StepperNavigationButtons";
import TitleList from "./TitleList";
import Tabs from "./Tab";

const TitleCustomizations = forwardRef(function TitleCustomizations(
  props,
  ref
) {
  const [titles, setTitles] = useState(props.Titles);
  const [currentTab, setCurrentTab] = useState(0);

  useEffect(() => {
    if (props.data) {
      setTitleData(props.data);
    }
  }, [props.data]);

  const setTitleData = (data) => {
    let titlesData = [];
    data.forEach((item, index) => {
      titlesData.push({
        title: item.title,
        sectionTitle: item.sectionTitle,
        sectionSubTitle: item.sectionSubTitle,
        navbarTitle: item.navbarTitle,
        show: index == 0,
        isValid: false,
        ref: null,
      });
    });
    setTitles(titlesData);
  };

  const validate = () => {
    let isValid = true;
    const currentTitles = [...titles];
    currentTitles.forEach((title) => {
      let validationStatus = title.ref?.validate() ?? false;
      title["isValid"] = validationStatus;

      if (!validationStatus) {
        isValid = false;
      }
    });
    setTitles(currentTitles);
    return isValid;
  };

  const getData = () => {
    let titlesData = [];

    titles.forEach((title) => {
      let data = title.ref?.getData() ?? null;
      if (data) titlesData.push(data);
    });
    return titlesData;
  };

  useImperativeHandle(ref, () => ({
    getData: getData,
    validate: validate,
  }));

  const handleTabClick = (index) => {
    setCurrentTab(index);
  };

  return (
    <div className="content d-block visible">
      <div className="content-header mb-3 d-flex justify-content-between">
        <div className="sec-titler">
          <h2 className="text-primary">Title Customizations</h2>
          <div className="title-shape"></div>
          <small className="fs-11 mb-0"></small>
        </div>
      </div>
      <form>
        <div className="row g-3">
          <div className="mt-3">
            <Tabs
              tabs={titles}
              currentTab={currentTab}
              onTabClick={handleTabClick}
            />
            <div className="tab-content">
              {titles.map((title, index) => (
                <div
                  key={index}
                  className={`tab-pane fade ${
                    currentTab === index ? "show active" : ""
                  }`}
                >
                  <TitleList
                    data={title}
                    index={index}
                    key={index}
                    ref={(el) => (title.ref = el)}
                  />
                </div>
              ))}
            </div>
          </div>

          <StepperNavigationButtons
            index={props.index}
            steps={props.steps}
            navigate={props.navigate}
            save={props.save}
          />
        </div>
      </form>
    </div>
  );
});

export default TitleCustomizations;
